import React from 'react';

const SvgParameters = props => (
  <svg
    id="parameters_svg__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <style>{'.parameters_svg__cls-1{fill:#989898}'}</style>
    </defs>
    <path
      className="parameters_svg__cls-1"
      d="M9.68 5.72a3.05 3.05 0 00-3-2.35 3.06 3.06 0 00-.7 6V20a.71.71 0 001.42 0V9.4a3.07 3.07 0 002.28-3.68zM7.4 7.92a1.71 1.71 0 01-.71.15A1.56 1.56 0 016 7.91a1.64 1.64 0 01-.94-1.56 1.59 1.59 0 01.16-.63A1.64 1.64 0 016 4.94a1.59 1.59 0 011.41 0 1.64 1.64 0 010 3zM12.71 14.6V4.13a.71.71 0 10-1.42 0V14.6a3.05 3.05 0 101.42 0zm-2.29 2.52a1.62 1.62 0 01.87-1 1.59 1.59 0 011.41 0 1.65 1.65 0 01.78 2.2 1.69 1.69 0 01-.78.78 1.64 1.64 0 01-2.19-.78 1.61 1.61 0 01-.09-1.17zM20.28 8.45A3 3 0 0018 6.19V4a.66.66 0 00-.71-.6.66.66 0 00-.7.61v2.18a3 3 0 000 5.94v7.8a.71.71 0 001.41 0v-7.8a3.06 3.06 0 002.28-3.68zm-4.62.72a1.65 1.65 0 012-1.61 2 2 0 01.34.12 1.64 1.64 0 010 3 1.56 1.56 0 01-.7.16 1.53 1.53 0 01-.64-.13 1.62 1.62 0 01-1-1.54z"
    />
  </svg>
);

export default SvgParameters;
